import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteApplicationMutationVariables = Types.Exact<{
  deleteApplicationId: Types.Scalars['ID']['input'];
}>;


export type DeleteApplicationMutation = { __typename?: 'Mutation', ghostwriter: { __typename?: 'GhostwriterMutations', deleteApplication: { __typename?: 'DeleteGhostwriterApplicationPayload', deletedApplicationId?: string | null, userErrors: Array<{ __typename?: 'GhostwriterUserError', code?: string | null, field?: Array<string> | null, message: string }> } } };


export const DeleteApplicationDocument = gql`
    mutation DeleteApplication($deleteApplicationId: ID!) {
  ghostwriter {
    deleteApplication(id: $deleteApplicationId) {
      deletedApplicationId
      userErrors {
        code
        field
        message
      }
    }
  }
}
    `;
export type DeleteApplicationMutationFn = Apollo.MutationFunction<DeleteApplicationMutation, DeleteApplicationMutationVariables>;

/**
 * __useDeleteApplicationMutation__
 *
 * To run a mutation, you first call `useDeleteApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApplicationMutation, { data, loading, error }] = useDeleteApplicationMutation({
 *   variables: {
 *      deleteApplicationId: // value for 'deleteApplicationId'
 *   },
 * });
 */
export function useDeleteApplicationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApplicationMutation, DeleteApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApplicationMutation, DeleteApplicationMutationVariables>(DeleteApplicationDocument, options);
      }
export type DeleteApplicationMutationHookResult = ReturnType<typeof useDeleteApplicationMutation>;
export type DeleteApplicationMutationResult = Apollo.MutationResult<DeleteApplicationMutation>;
export type DeleteApplicationMutationOptions = Apollo.BaseMutationOptions<DeleteApplicationMutation, DeleteApplicationMutationVariables>;